// Private original pixels only. Missing region metadata shows one original.
export class PhotoQuestionSession {
    public areas: Record<string, string> = {};
    public edits: Record<string, string> = {};
    public message = '';
    private signature = '';
    private epoch = 0;
    key(area: any) { return area.image_id + ':' + JSON.stringify(area.region); }
    clear() {
        this.epoch++; this.signature = ''; this.message = ''; this.edits = {};
        Object.values(this.areas).forEach(url => URL.revokeObjectURL(url)); this.areas = {};
    }
    async configure(run: any, token: string) {
        const questions = run?.execution_kind === 'preparation' ? run.preparation?.clarification?.questions || [] : [];
        const signature = JSON.stringify([run?.id, token, questions]);
        if (this.signature === signature) return;
        this.clear(); this.signature = signature;
        const epoch = this.epoch;
        for (const area of questions.flatMap((q: any) => q.evidence)) {
            const key = this.key(area);
            if (this.areas[key]) continue;
            let original = '';
            try {
                const response = await fetch('/api/saju/uploads/images/' + area.image_id, { credentials: 'include', cache: 'no-store', headers: { Authorization: 'Bearer ' + token } });
                if (!response.ok) throw new Error();
                const blob = await response.blob();
                original = URL.createObjectURL(blob);
                let url = original;
                if (area.region) {
                    const picture = new Image(); picture.src = original; await picture.decode();
                    const r = area.region, canvas = document.createElement('canvas');
                    canvas.width = Math.max(1, Math.round(r.width * picture.naturalWidth));
                    canvas.height = Math.max(1, Math.round(r.height * picture.naturalHeight));
                    canvas.getContext('2d')!.drawImage(picture, r.x * picture.naturalWidth, r.y * picture.naturalHeight,
                        r.width * picture.naturalWidth, r.height * picture.naturalHeight, 0, 0, canvas.width, canvas.height);
                    const crop = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve));
                    if (crop) { url = URL.createObjectURL(crop); URL.revokeObjectURL(original); original = ''; }
                }
                if (epoch !== this.epoch) { URL.revokeObjectURL(url); return; }
                this.areas[key] = url;
            } catch {
                if (original) URL.revokeObjectURL(original);
                if (epoch === this.epoch) this.message = '원본을 불러오지 못했어요. 상태를 다시 조회해 주세요.';
            }
        }
    }
}
